/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The foundation you already know`)
};

const es_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La base que ya conoces`)
};

const de_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Grundlage kennen Sie bereits`)
};

const zh_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你早已熟悉的基础`)
};

const ar_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القاعدة التي تعرفها بالفعل`)
};

const fr_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fondation que vous connaissez déjà`)
};

const vi_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng bạn đã biết`)
};

const sw_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misingi unayoijua tayari`)
};

const th_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รากฐานที่คุณรู้จักอยู่แล้ว`)
};

const bs_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osnova koju već znaš`)
};

const ja_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたがすでに知っている土台`)
};

const ko_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 알고 있는 토대`)
};

const pt_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A base que você já conhece`)
};

const it_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La base che conosci già`)
};

const sv_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grunden du redan kan`)
};

const nl_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De basis die je al kent`)
};

const da_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det fundament, du allerede kender`)
};

const nb_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grunnlaget du allerede kjenner`)
};

const fi_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perusta, jonka jo tunnet`)
};

const pl_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundament, który już znasz`)
};

const ru_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основа, которую вы уже знаете`)
};

const tr_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten tanıdığınız temeller`)
};

const hi_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह नींव जिसे आप पहले से जानते हैं`)
};

const id_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar-dasar yang sudah Anda kenal`)
};

const ms_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asas yang sudah anda kenali`)
};

const cs_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základ, který už znáte`)
};

const el_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το θεμέλιο που ήδη γνωρίζετε`)
};

const he_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הבסיס שאתם כבר מכירים`)
};

const af_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die fondament wat jy reeds ken`)
};

const hu_method_content_step_01_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az alap, amelyet már ismersz`)
};

/**
* | output |
* | --- |
* | "The foundation you already know" |
*
* @param {Method_Content_Step_01_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_amateur_0_heading(inputs)
	return en_method_content_step_01_detail_amateur_0_heading(inputs)
});